import * as React from 'react';
import { ArticleParagraph3, Button, FormField, Input, ModalWindow, Textarea } from '@cian/ui-kit';
import { IFeedbackRequest, IFeedbackResponse } from '../../../../types/feedback';
import { trackCloseFeedbackForm, trackSubmitFeedbackForm } from '../../../../utils/analytics';

import * as styles from './index.css';

interface IModalFormProps {
  sendFeedbackAction(params: IFeedbackRequest): Promise<IFeedbackResponse>;
  showSuccessAlert(): void;
  onModalClose(): void;
  isMobile?: boolean;
}

interface IModalFormState {
  name: string;
  email: string;
  companyName: string;
  phone: string;
  comment: string;
  validated: boolean;

  companyNameValidatorMessage?: string;
  contactValidatorMessage?: string;
  emailValidatorMessage?: string;
  phoneValidatorMessage?: string;
  serverErrorMessage?: string;
}

const validatorMessages: {
  [key: string]: string;
} = {
  companyName: 'Укажите название компании',
  phone: 'Укажите телефон',
};

export class ModalForm extends React.Component<IModalFormProps, IModalFormState> {
  public constructor(props: IModalFormProps) {
    super(props);

    this.state = {
      comment: '',
      companyName: '',
      email: '',
      name: '',
      phone: '',
      validated: false,
    };
  }

  public render() {
    const {
      comment,
      companyName,
      email,
      name,
      phone,
      companyNameValidatorMessage,
      phoneValidatorMessage,
      serverErrorMessage,
    } = this.state;

    const { isMobile } = this.props;

    const buttonSize = isMobile ? 'M' : 'XS';

    return (
      <ModalWindow
        width={648}
        open
        fixed
        onClose={this.onModalFormClose}
        title="Заявка на добавление посёлка в каталог"
        footer={
          <div className={styles['footer']}>
            {serverErrorMessage && (
              <div className={styles['error']}>
                <ArticleParagraph3 color="error_100">{serverErrorMessage}</ArticleParagraph3>
              </div>
            )}
            <Button fullWidth={isMobile} onClick={() => this.sendRequest()} type="submit" size={buttonSize}>
              Отправить
            </Button>
          </div>
        }
      >
        <div className={styles['content']}>
          <FormField label="Название компании" required errorMessage={companyNameValidatorMessage}>
            <Input
              autoFocus
              value={companyName}
              onChange={(_, value) => this.onCompanyNameValueChange(value)}
              data-name="AddFormVillageName"
            />
          </FormField>
          <FormField label="Имя и фамилия">
            <Input value={name} onChange={(_, value) => this.setState({ name: value })} data-name="AddFormUserName" />
          </FormField>
          <FormField label="Телефон" required errorMessage={phoneValidatorMessage}>
            <Input
              value={phone}
              onChange={(_, value) => this.onPhoneValueChange(value)}
              placeholder="+7"
              width={230}
              data-name="AddFormPhone"
            />
          </FormField>
          <FormField label="Электронная почта">
            <Input
              value={email}
              onChange={(_, value) => this.setState({ email: value })}
              width={230}
              data-name="AddFormEmail"
            />
          </FormField>
          <FormField label="Комментарий">
            <Textarea
              onChange={(_, value) => this.onCommentValueChange(value)}
              value={comment}
              minRows={3}
              maxRows={3}
              data-name="AddFormComment"
            />
          </FormField>
        </div>
      </ModalWindow>
    );
  }

  private onModalFormClose = () => {
    this.props.onModalClose();
    trackCloseFeedbackForm();
  };

  private onCommentValueChange = (value: string) => {
    this.setState({
      comment: value,
    });
  };

  private onCompanyNameValueChange(companyName: string) {
    if (!this.state.validated) {
      this.setState({ companyName });

      return;
    }

    this.setState({
      companyName,
      companyNameValidatorMessage: companyName.length === 0 ? validatorMessages.companyName : undefined,
    });
  }

  private onPhoneValueChange(phone: string) {
    if (!this.state.validated) {
      this.setState({ phone });

      return;
    }

    this.setState({
      phone,
      phoneValidatorMessage: phone.length === 0 ? validatorMessages.phone : undefined,
    });
  }

  private handleServerError = () => {
    this.setState({ serverErrorMessage: 'Ошибка. Попробуйте ещё раз' });
  };

  private sendRequest() {
    const { sendFeedbackAction, showSuccessAlert } = this.props;
    this.setState({ validated: true, serverErrorMessage: undefined });

    if (!this.validateRequiredFields()) {
      return;
    }

    sendFeedbackAction(this.prepareMessage())
      .then((data: IFeedbackResponse) => {
        if (data.status !== 'ok') {
          return this.handleServerError();
        }
        showSuccessAlert();
      })
      .catch(this.handleServerError);
    trackSubmitFeedbackForm();
  }

  private validateRequiredFields(): boolean {
    const { companyName, phone } = this.state;

    let isValid = true;

    const companyNameValidatorMessage = companyName && companyName.length ? undefined : validatorMessages.companyName;
    const phoneValidatorMessage = phone && phone.length ? undefined : validatorMessages.phone;

    if (companyNameValidatorMessage || phoneValidatorMessage) {
      isValid = false;
    }

    this.setState({
      companyNameValidatorMessage,
      phoneValidatorMessage,
    });

    return isValid;
  }

  private prepareMessage() {
    const { companyName, comment, phone, name, email } = this.state;

    const message = `
        Название компании
        ${companyName}
        Имя и фамилия
        ${name}
        Телефон
        ${phone}
        Email
        ${email}
        Комментарий
        ${comment}
    `;

    return {
      source: 'kp_request',
      text: message,
      url: window.location.href,
    };
  }
}
